import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Centers
  centers: [],
  centersLoading: false,
  centersError: null,
  selectedCenter: null,

  // Camps
  camps: [],
  campsLoading: false,
  campsError: null,
  selectedCamp: null,

  // Camp dates & accommodation
  campDates: null,  // { camp_Id, accommodationFee, campStartDate, campEndDate }
  campDatesLoading: false,

  // Students
  unregisteredStudents: [],
  registeredStudents: [],
  studentsLoading: false,
  studentsError: null,

  // Registration tracking
  lastRegInfo: null,  // { studentId, registrationId }

  // Fee calculation
  calculation: null,
  calcLoading: false,

  // Payment info (passed to payment page)
  paymentInfo: null,  // { registrationId, userId, campId }
};

const campSlice = createSlice({
  name: 'camp',
  initialState,
  reducers: {
    // Centers
    setCenters: (state, action) => {
      state.centers = action.payload;
      state.centersError = null;
    },
    setCentersLoading: (state, action) => {
      state.centersLoading = action.payload;
    },
    setCentersError: (state, action) => {
      state.centersError = action.payload;
    },
    setSelectedCenter: (state, action) => {
      state.selectedCenter = action.payload;
    },

    // Camps
    setCamps: (state, action) => {
      state.camps = action.payload;
      state.campsError = null;
    },
    setCampsLoading: (state, action) => {
      state.campsLoading = action.payload;
    },
    setCampsError: (state, action) => {
      state.campsError = action.payload;
    },
    setSelectedCamp: (state, action) => {
      state.selectedCamp = action.payload;
    },

    // Camp dates
    setCampDates: (state, action) => {
      state.campDates = action.payload;
    },
    setCampDatesLoading: (state, action) => {
      state.campDatesLoading = action.payload;
    },

    // Students
    setUnregisteredStudents: (state, action) => {
      state.unregisteredStudents = action.payload;
    },
    setRegisteredStudents: (state, action) => {
      state.registeredStudents = action.payload;
    },
    setStudentsLoading: (state, action) => {
      state.studentsLoading = action.payload;
    },
    setStudentsError: (state, action) => {
      state.studentsError = action.payload;
    },

    // Registration
    setLastRegInfo: (state, action) => {
      state.lastRegInfo = action.payload;
    },

    // Calculation
    setCalculation: (state, action) => {
      state.calculation = action.payload;
      state.calcLoading = false;
    },
    setCalcLoading: (state, action) => {
      state.calcLoading = action.payload;
    },
    clearCalculation: (state) => {
      state.calculation = null;
    },

    // Payment info
    setPaymentInfo: (state, action) => {
      state.paymentInfo = action.payload;
    },
    clearPaymentInfo: (state) => {
      state.paymentInfo = null;
    },

    // Reset full module state
    clearCampData: () => initialState,

    // Reset student/reg data when camp changes
    clearRegistrationData: (state) => {
      state.unregisteredStudents = [];
      state.registeredStudents = [];
      state.studentsError = null;
      state.lastRegInfo = null;
      state.calculation = null;
      state.paymentInfo = null;
      state.campDates = null;
    },
  },
});

export const {
  setCenters,
  setCentersLoading,
  setCentersError,
  setSelectedCenter,
  setCamps,
  setCampsLoading,
  setCampsError,
  setSelectedCamp,
  setCampDates,
  setCampDatesLoading,
  setUnregisteredStudents,
  setRegisteredStudents,
  setStudentsLoading,
  setStudentsError,
  setLastRegInfo,
  setCalculation,
  setCalcLoading,
  clearCalculation,
  setPaymentInfo,
  clearPaymentInfo,
  clearCampData,
  clearRegistrationData,
} = campSlice.actions;

export default campSlice.reducer;
